import {
  ExportService,
  ExportFileFormat,
  ExportContext,
} from "app/layout/export-overlay";
import { Injectable } from "@angular/core";
import { get } from "lodash-es";
import { WORK_COURSER_CUSTOMER_EXPORT_ID, WORK_COURSER_CUSTOMER_PROPERTIES, WORK_COURSER_CUSTOMER_TITLE } from "./work-course-customer.constants";

@Injectable()
export class WorkCourseCustomerExport {
  private currentData: any[] = [];

  constructor(private exportService: ExportService) {}

  setData(data: any[]) {
    this.currentData = data;
  }

  private transform(): any[] {

    return this.currentData.flatMap((item: any) =>
      item.orders.flatMap((order: any) =>
        order.detail.map((detail: any) => ({
          soldToCode: get(order, "soldTo.externalKeys.code", ""),
          soldToName: get(order, "soldTo.name", ""),
          shipToCode: get(item, "shipTo.externalKeys.code", ""),
          shipToName: get(item, "shipTo.name", ""),
          serial: get(order, "serial", ""),
          className: get(order, "class.name", ""),
          materialCode: get(detail, "material.code", ""),
          materialName: get(detail, "material.name", ""),
          soldQuantity: get(detail, "soldQuantity", ""),
          soldUnit: get(detail, "soldUnitOfMeasure.name", ""),
          baseQuantity: get(detail, "baseQuantity", ""),
          baseUnit: get(detail, "baseUnitOfMeasure.name", ""),
          parallelQuantity: get(detail, "pararellQuantity", ""),
          parallelUnit: get(detail, "pararellUnitOfMeasure.name", ""),
          finalPrice: get(detail, "subTotal", ""),
          discounts: get(detail, "totalDiscounts", ""),
          surcharges: get(detail, "totalSurcharges", ""),
          subtotal: get(detail, "subTotalBeforeTaxes", ""),
          taxes: get(detail, "totalTaxes", ""),
          total: get(detail, "total", "")
        }))
      )
    );
  }

  export(format: ExportFileFormat) {
    this.exportService
      .task({
        id: WORK_COURSER_CUSTOMER_EXPORT_ID,
        title: WORK_COURSER_CUSTOMER_TITLE,
        format,
        iterations: 1,
        start: (ctx: ExportContext) => {
          ctx.processor.localizeItemProperties(
            WORK_COURSER_CUSTOMER_TITLE,
            WORK_COURSER_CUSTOMER_PROPERTIES
          );
        },
        next: (ctx: ExportContext) => {
          const rows = this.transform();
          ctx.processor.addToSection(WORK_COURSER_CUSTOMER_TITLE, rows);
          ctx.next();
        },
      })
      .start();
  }

  canStartTask(): boolean {
    if (this.exportService.taskIsActive(WORK_COURSER_CUSTOMER_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}